import { StatCard } from '@/client/components/common/StatCard';
// src/client/components/projects/ProjectDetailStatCards.tsx
import { CalendarDays, Users } from 'lucide-react';

interface Props {
  memberCount: number;
  createdAt: string;
}

export function ProjectDetailStatCards({ memberCount, createdAt }: Props) {
  const created = new Date(createdAt).toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });
  return (
    <div className="grid grid-cols-2 gap-3">
      <StatCard label="Team members" value={memberCount} icon={Users} tone="primary" />
      <StatCard label="Created" value={created} icon={CalendarDays} />
    </div>
  );
}
